// Dashboard translations (pt-BR), loaded into common/i18n/pt-BR.js as `dashboard`
module.exports = {
  title: "Dashboard",
  placeholder: "Página em construção — o conteúdo chega numa próxima tarefa.",
  overview: {
    ...require("./overview/pt-BR.totals"),
    menu: "Visão Geral",
    title: "Visão Geral",
    description: "Os números gerais do VOXGO, acumulados desde o início.",
    kpis: {
      totalUsers: "Total de utilizadores",
      activeUsers: "Utilizadores ativos no período",
      activeUsers7d: "Utilizadores ativos 7 dias",
      activeUsers30d: "Utilizadores ativos 30 dias",
      newUsers: "Novos utilizadores",
      newUsersPerDay: "Média de novos por dia",
      growth: "Crescimento vs. período anterior",
      onlineNow: "Utilizadores online agora",
      avgSession: "Tempo médio na aplicação",
      sessionsPerUser: "Média de sessões por utilizador",
      eventsCreated: "Eventos criados",
      eventClicks: "Cliques em eventos",
    },
    info: {
      totalUsers: "Contas registadas na plataforma no último dia do período.\nFonte: Firebase (contadores de registos).",
      activeUsers: "Utilizadores únicos que usaram a app pelo menos uma vez no período.\nFonte: Firebase (registo de atividade enviado pelas apps).",
      activeUsers7d: "Utilizadores únicos que usaram a app nos 7 dias até ao fim do período.\nFonte: Firebase (registo de atividade enviado pelas apps).",
      activeUsers30d: "Utilizadores únicos que usaram a app nos 30 dias até ao fim do período.\nFonte: Firebase (registo de atividade enviado pelas apps).",
      newUsers: "Contas criadas no período.\nFonte: Firebase (contadores de registos).",
      newUsersPerDay: "Média de contas criadas por dia no período.\nFonte: Firebase (contadores de registos).",
      growth: "Variação dos novos utilizadores face ao período anterior de igual duração.\nFonte: Firebase (contadores de registos).",
      onlineNow: "Utilizadores com a app aberta nos últimos 30 minutos, em tempo real (não depende do período).\nFonte: Firebase (sinal de presença enviado pelas apps).",
      avgSession: "Tempo médio de cada sessão na app no período.\nFonte: Firebase (registo de atividade enviado pelas apps).",
      sessionsPerUser: "Média de vezes que cada utilizador ativo abriu a app no período.\nFonte: Firebase (registo de atividade enviado pelas apps).",
      eventsCreated: "Eventos criados no período.\nFonte: Firebase (contadores de eventos).",
      eventClicks: "Cliques nos links de eventos no período.\nFonte: Firebase (contadores de eventos).",
    },
    hints: {
      window7: "7 dias até ao fim do período",
      window30: "30 dias até ao fim do período",
      shorterThan7: "período inferior a 7 dias",
      shorterThan30: "período inferior a 30 dias",
      oneDay: "período de apenas 1 dia",
      growth: "novos utilizadores",
      onlineNow: "últimos 30 minutos",
    },
    modals: {
      activeUsers: "Utilizadores ativos",
      activeUsersSubtitle: "média diária de ativos",
      avgSession: "Tempo médio por sessão",
    },
    panels: {
      evolution: "Evolução — novos utilizadores por {gran}",
      windows: "Novos utilizadores — este período vs. anteriores",
      windowsNote: "Cada barra tem a mesma duração do período selecionado.",
      actives: "Utilizadores ativos (média) por {gran}",
      events: "Eventos criados por {gran}",
    },
    minutes: "{value} min",
    maps: {
      users: {
        title: "Utilizadores",
        tabs: {total: "Total", continents: "Continentes", countries: "Países"},
        labels: {total: "utilizadores registados", continents: "utilizadores registados", countries: "utilizadores registados"},
      },
      events: {
        title: "Eventos",
        tabs: {all: "Todos", active: "Ativos", perDay: "Média por dia"},
        labels: {all: "eventos criados até ao fim do período", active: "eventos ativos no último dia do período", perDay: "eventos criados por dia no período (média), por país no mapa"},
      },
      voxpoints: {
        title: "VoxPoints",
        tabs: {total: "Total"},
        labels: {total: "VoxPoints ativos"},
      },
    },
    panelInfo: {
      usersMap: {
        total: "Utilizadores registados no último dia do período, por cidade da morada.\nFonte: Firebase (contadores de registos).",
        continents: "Utilizadores registados no último dia do período, por continente da morada.\nFonte: Firebase (contadores de registos).",
        countries: "Utilizadores registados no último dia do período, por país da morada.\nFonte: Firebase (contadores de registos).",
      },
      eventsMap: {
        all: "Eventos criados desde o início até ao fim do período, incluindo os apagados, por cidade.\nFonte: Firebase (contadores de eventos).",
        active: "Eventos ativos a decorrer no último dia do período, por local.\nFonte: Firebase (eventos).",
        perDay: "Média de eventos criados por dia no período; no mapa, a média por dia de cada país.\nFonte: Firebase (contadores de eventos).",
      },
      voxpointsMap: {
        total: "Todos os VoxPoints cadastrados, um pin por VoxPoint; país e cidade são os da cidade conhecida mais próxima.\nFonte: Firebase (VoxPoints).",
      },
      evolution: "Contas criadas em cada intervalo do período.\nFonte: Firebase (contadores de registos).",
      windows: "Contas criadas neste período e nos anteriores de igual duração.\nFonte: Firebase (contadores de registos).",
      actives: "Média de utilizadores ativos por dia em cada intervalo.\nFonte: Firebase (registo de atividade enviado pelas apps).",
      events: "Eventos criados em cada intervalo.\nFonte: Firebase (contadores de eventos).",
    },
  },
  users: require('./pt-BR.users.js'),
  events: require('./pt-BR.events.js'),
  usage: require('./pt-BR.usage.js'),
  moderation: require('./pt-BR.moderation.js'),
  period: {
    presets: {
      today: "Hoje",
      yesterday: "Ontem",
      last7: "Últimos 7 dias",
      last30: "Últimos 30 dias",
      last90: "Últimos 90 dias",
      thisMonth: "Este mês",
      thisYear: "Este ano",
    },
    startDate: "Data de início",
    endDate: "Data de fim",
    apply: "Aplicar",
    period: "Período:",
    day: "dia | dias",
    chartsBy: "Gráficos por",
    comparedWith: "Comparação com",
    granularity: {
      hour: "hora",
      day: "dia",
      week: "semana",
      month: "mês",
    },
    comparison: {
      previousDay: "vs. dia anterior",
      previousMonth: "vs. mês anterior",
      previousYear: "vs. ano anterior",
      previousPeriod: "vs. período anterior",
    },
    modalFooter: "Período: {range} · por {gran}",
  },
  header: {
    updatedNow: "Atualizado agora",
    updatedAgo: "Atualizado há {n} min",
  },
  kpi: {
    expand: "Expandir",
    live: "Tempo real",
  },
  state: {
    loading: "A carregar…",
    empty: "Sem dados no período selecionado.",
    unavailable: "n/d",
    unavailableHint: "Indisponível para o período selecionado.",
  },
  modal: {
    close: "Fechar",
  },
  chart: {
    noData: "sem dados",
  },
  map: {
    roadmap: "Mapa",
    satellite: "Satélite",
    less: "Menos",
    more: "Mais",
    andMore: "e mais {n}",
    fullscreen: "Ecrã inteiro",
    zoomIn: "Aumentar",
    zoomOut: "Diminuir",
  },
  cohort: {
    week: "Semana",
    month: "Mês",
    users: "Utilizadores",
    weekColumn: "Sem {n}",
    dayColumn: "Dia {n}",
  },
  format: {
    thousand: "{value} mil",
    million: "{value} M",
    duration: "{minutes} min {seconds} s",
    percentagePoints: "{value} p.p.",
  },
};
